import React from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'

import styles from './card.module.css'

const propTypes = {
    className: PropTypes.string,
    isActive: PropTypes.bool,
    title: PropTypes.string.isRequired
}

const defaultProps = {
    isActive: false
}

/**
 * Render card separator.
 *
 * @param {string} props.title - Title for the separator
 * @param {boolean} [props.isActive=false] - Whether the separator has an active green line
 * @param {string} [props.className] - Optional classname for the wrapper
 * @returns {ReactElement}
 */
export function CardSeparator(props) {
    const { className, isActive, title } = props
    const combinedClassName = cx(styles['card-separator'], { [styles['active']]: isActive }, className)

    return <div className={combinedClassName}>{title}</div>
}

CardSeparator.propTypes = propTypes
CardSeparator.defaultProps = defaultProps
